(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6989],{

/***/ 18295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/list",
      function () {
        return __webpack_require__(73291);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ Alert; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Error.js
var Error = __webpack_require__(72063);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Info.js
var Info = __webpack_require__(18362);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Notifications.js
var Notifications = __webpack_require__(48825);
// EXTERNAL MODULE: ./components/Alert/Alert.module.scss
var Alert_module = __webpack_require__(63266);
var Alert_module_default = /*#__PURE__*/__webpack_require__.n(Alert_module);
;// CONCATENATED MODULE: ./components/Alert/Alert.tsx







function mapTypeToIcon(type) {
    switch(type){
        case "info":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                "aria-label": "Information"
            });
        case "alert":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notifications/* default */.Z, {
                "aria-label": "Alert"
            });
        case "error":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                "aria-label": "Error"
            });
    }
}
var Alert = function(props) {
    var type = props.type, message = props.message, callToActionChildren = props.callToActionChildren;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Alert_module_default()).notice,
        role: "status",
        "data-testid": props["data-testid"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Alert_module_default()).messageContainer,
                children: [
                    mapTypeToIcon(type),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Alert_module_default()).callToActionChildren,
                children: callToActionChildren
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Alert/index.ts



/***/ }),

/***/ 72781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JobListing_JobListing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./modules/JobAlerts/index.tsx + 7 modules
var JobAlerts = __webpack_require__(47988);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Clear.js
var Clear = __webpack_require__(35996);
// EXTERNAL MODULE: ./components/ClearableTextField/ClearableTextField.module.scss
var ClearableTextField_module = __webpack_require__(48166);
var ClearableTextField_module_default = /*#__PURE__*/__webpack_require__.n(ClearableTextField_module);
;// CONCATENATED MODULE: ./components/ClearableTextField/ClearableTextField.tsx








var ClearableTextField = function(_param) /*#__PURE__*/ {
    var hasClear = _param.hasClear, _onClear = _param.onClear, onClear = _onClear === void 0 ? function() {
        return null;
    } : _onClear, value = _param.value, _InputProps = _param.InputProps, InputProps = _InputProps === void 0 ? {} : _InputProps, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "hasClear",
        "onClear",
        "value",
        "InputProps",
        "className"
    ]);
    return (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        value: value,
        InputProps: (0,_object_spread/* default */.Z)({
            endAdornment: hasClear && value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    "aria-label": "clear",
                    onClick: onClear,
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    },
                    edge: "end",
                    size: "small",
                    className: (ClearableTextField_module_default()).textFieldClearButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {
                        fontSize: "small"
                    })
                })
            }) : null
        }, InputProps),
        className: classnames_default()((ClearableTextField_module_default()).textField, className)
    }, rest));
};
/* harmony default export */ var ClearableTextField_ClearableTextField = (ClearableTextField);

;// CONCATENATED MODULE: ./components/ClearableTextField/index.tsx


// EXTERNAL MODULE: ./components/DropdownList/index.tsx + 1 modules
var DropdownList = __webpack_require__(62184);
// EXTERNAL MODULE: ./components/LocationSearchAutocomplete/index.tsx + 1 modules
var LocationSearchAutocomplete = __webpack_require__(70884);
// EXTERNAL MODULE: ./utils/dateHelper.ts
var dateHelper = __webpack_require__(78219);
;// CONCATENATED MODULE: ./utils/jobSearchAutoScroll.tsx
var storageSettings;
(function(storageSettings) {
    storageSettings["key"] = "JobSearchBox";
    storageSettings["behaviorSmooth"] = "smooth";
    storageSettings["behaviorInstant"] = "auto";
})(storageSettings || (storageSettings = {}));
var scrollToResultsWhenRendered = function(scrollToResultsRef) {
    var jobSearchBoxData = sessionStorage.getItem(storageSettings.key);
    if (jobSearchBoxData && JSON.parse(jobSearchBoxData).scrollToResults) {
        var ref;
        var _behavior;
        var behavior = (_behavior = JSON.parse(jobSearchBoxData).behavior) !== null && _behavior !== void 0 ? _behavior : storageSettings.behaviorSmooth;
        scrollToResultsRef === null || scrollToResultsRef === void 0 ? void 0 : (ref = scrollToResultsRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: behavior
        });
    }
};
var setScrollInstantOnFilterChangeRerender = function() {
    var jobSearchBoxData = sessionStorage.getItem(storageSettings.key);
    if (jobSearchBoxData && JSON.parse(jobSearchBoxData).scrollToResults) {
        sessionStorage.setItem(storageSettings.key, JSON.stringify({
            scrollToResults: true,
            behavior: storageSettings.behaviorInstant
        }));
    }
};
var enableScrollWhenSearchInitiated = function() {
    sessionStorage.setItem(storageSettings.key, JSON.stringify({
        scrollToResults: true,
        behavior: storageSettings.behaviorSmooth
    }));
};
var clearScrollWhenSearchCriteriaHasChanged = function() {
    sessionStorage.setItem(storageSettings.key, JSON.stringify({
        scrollToResults: false,
        behavior: storageSettings.behaviorSmooth
    }));
};

// EXTERNAL MODULE: ./node_modules/@date-io/date-fns/build/index.esm.js + 76 modules
var index_esm = __webpack_require__(58308);
// EXTERNAL MODULE: ./node_modules/@material-ui/pickers/esm/useUtils-cfb96ac9.js
var useUtils_cfb96ac9 = __webpack_require__(87827);
// EXTERNAL MODULE: ./node_modules/@material-ui/pickers/esm/DatePicker.js + 16 modules
var DatePicker = __webpack_require__(7637);
// EXTERNAL MODULE: ./modules/JobSearchFilters/components/DatePickers/DatePickers.module.scss
var DatePickers_module = __webpack_require__(78192);
var DatePickers_module_default = /*#__PURE__*/__webpack_require__.n(DatePickers_module);
;// CONCATENATED MODULE: ./modules/JobSearchFilters/components/DatePickers/DatePickers.tsx










var formatDate = function(date) {
    if (!date) {
        return null;
    }
    var formattedDate = (0,dateHelper/* parseAndFormatDate */.PN)(date, "YYYY-MM-DD");
    // return 'none' for invalid date to trigger the inline error message
    return formattedDate ? formattedDate : "none";
};
/**
 * Adds start and end date selection capabilities to the Job Search box.
 * This is a 'heavy' component that should be lazy loaded only when the job search component is configured to actually
 * render the date pickers
 * @param date The startDate and endDate of the current search
 * @param onDateChange A function that is called when the startDate or endDate are updated. Accepts a parameter of type DateSearch
 * @param isEndDateDisabled If true, disables the endDate date picker.
 * @param startDateClassname Layout styles.
 * @param endDateClassname Layout styles.
 * @constructor
 */ var DatePickers = function(param) {
    var date = param.date, onDateChange = param.onDateChange, isEndDateDisabled = param.isEndDateDisabled, startDateClassname = param.startDateClassname, endDateClassname = param.endDateClassname;
    var formattedDate = {
        startDate: formatDate(date.startDate),
        endDate: formatDate(date.endDate)
    };
    var variant = "dialog";
    var clearLabel = "CLEAR";
    var invalidDateMessage = "Invalid date";
    var format = "dd.MM.yyyy";
    var inputVariant = "outlined";
    var className = (DatePickers_module_default()).outlinedPicker;
    var handleStartDateChange = function(v) {
        onDateChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formattedDate), {
            startDate: formatDate(v)
        }));
        clearScrollWhenSearchCriteriaHasChanged();
    };
    var handleEndDateChange = function(v) {
        onDateChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formattedDate), {
            endDate: formatDate(v)
        }));
        clearScrollWhenSearchCriteriaHasChanged();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(useUtils_cfb96ac9.M, {
        utils: index_esm/* default */.Z,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((DatePickers_module_default()).container, startDateClassname),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* KeyboardDatePicker */.e, {
                    variant: variant,
                    clearable: true,
                    clearLabel: clearLabel,
                    format: format,
                    autoOk: true,
                    inputVariant: inputVariant,
                    className: className,
                    fullWidth: true,
                    invalidDateMessage: invalidDateMessage,
                    label: "Start date",
                    value: formattedDate.startDate,
                    onChange: handleStartDateChange,
                    KeyboardButtonProps: {
                        "aria-label": "change date"
                    },
                    inputProps: {
                        "data-testid": "job-search-start-date-input"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((DatePickers_module_default()).container, endDateClassname),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* KeyboardDatePicker */.e, {
                    disabled: isEndDateDisabled,
                    variant: variant,
                    clearable: true,
                    clearLabel: clearLabel,
                    format: format,
                    autoOk: true,
                    inputVariant: inputVariant,
                    className: className,
                    invalidDateMessage: invalidDateMessage,
                    fullWidth: true,
                    label: "End date",
                    minDateMessage: "The end date cannot be earlier than the start date",
                    minDate: formattedDate.startDate,
                    disablePast: true,
                    value: formattedDate.endDate,
                    onChange: handleEndDateChange,
                    KeyboardButtonProps: {
                        "aria-label": "change date"
                    },
                    inputProps: {
                        "data-testid": "job-search-end-date-input"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var DatePickers_DatePickers = (DatePickers);

// EXTERNAL MODULE: ./utils/jobSearchBoxOptions.tsx
var jobSearchBoxOptions = __webpack_require__(73208);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonGroup/ButtonGroup.js
var ButtonGroup = __webpack_require__(24837);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 3 modules
var Autocomplete = __webpack_require__(53437);
// EXTERNAL MODULE: ./modules/JobSearchFilters/components/MinPayRateDropdown/MinPayRateDropdown.module.scss
var MinPayRateDropdown_module = __webpack_require__(83333);
var MinPayRateDropdown_module_default = /*#__PURE__*/__webpack_require__.n(MinPayRateDropdown_module);
;// CONCATENATED MODULE: ./modules/JobSearchFilters/components/MinPayRateDropdown/MinPayRateDropdown.tsx










var MinPayRateDropdown = function(param) {
    var minPayRate = param.minPayRate, onMinPayRateChange = param.onMinPayRateChange, minPayRateUnit = param.minPayRateUnit, onMinPayRateUnitChange = param.onMinPayRateUnitChange;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var containerRef = (0,react.useRef)();
    var paperRef = (0,react.useRef)();
    // a click on custom buttons in dropdown
    // triggers onBlur event on the input field
    // which closes the dropdown
    // we disable close-on-blur behaviour inside onClose callback
    // and add custom listeners below
    var handleOutsideClick = (0,react.useCallback)(function(e) {
        if (open) {
            if (containerRef.current && containerRef.current.contains(e.target) || paperRef.current && paperRef.current.contains(e.target)) {
                // inside click
                return;
            }
            // outside click
            setOpen(false);
        }
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        handleOutsideClick
    ]);
    // end of custom listeners
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        value: minPayRate !== null && minPayRate !== void 0 ? minPayRate : null,
        onChange: function(_e, value) {
            onMinPayRateChange(value);
        },
        ref: containerRef,
        "data-testid": "job-search-min-pay-rate-container",
        fullWidth: true,
        open: open,
        onOpen: function(_e) {
            return setOpen(true);
        },
        onClose: function(e) {
            // disable closing dropdown on input blur
            if (e.type !== "blur") {
                setOpen(false);
            }
        },
        options: jobSearchBoxOptions/* MIN_PAY_RATES */.XG[minPayRateUnit],
        getOptionLabel: function(option) {
            return "$".concat(option);
        },
        autoHighlight: true,
        clearOnBlur: true,
        renderInput: function(params) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                label: "Est. minimum pay rate",
                fullWidth: true,
                inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.inputProps), {
                    "data-testid": "job-search-min-pay-rate-input"
                }),
                InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps), {
                    startAdornment: minPayRate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputAdornment/* default */.Z, {
                        position: "start",
                        children: [
                            minPayRateUnit,
                            ":"
                        ]
                    }) : null
                })
            }));
        },
        PaperComponent: function(_param) {
            var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
                "children"
            ]);
            var getButton = function(unit) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: function(e) {
                        if (unit !== minPayRateUnit) {
                            onMinPayRateUnitChange(unit);
                            onMinPayRateChange(null); // reset minPayRate value when unit is changed
                        }
                    },
                    size: "small",
                    "data-testid": "job-search-min-pay-rate-unit-button-".concat(unit.toLowerCase()),
                    className: classnames_default()((MinPayRateDropdown_module_default()).button, minPayRateUnit === unit ? (MinPayRateDropdown_module_default()).active : null),
                    color: minPayRateUnit === unit ? "primary" : "default",
                    variant: minPayRateUnit === unit ? "contained" : "outlined",
                    "aria-current": minPayRateUnit === unit,
                    children: unit
                });
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                ref: paperRef,
                className: (MinPayRateDropdown_module_default()).dropdown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MinPayRateDropdown_module_default()).buttonGroup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                            disableElevation: true,
                            fullWidth: true,
                            children: [
                                getButton("Hourly"),
                                getButton("Daily")
                            ]
                        })
                    }),
                    children
                ]
            }));
        },
        ListboxProps: {
            style: {
                maxHeight: 180,
                overflow: "auto"
            },
            "data-testid": "job-search-min-pay-rate-value-list"
        }
    });
};
/* harmony default export */ var MinPayRateDropdown_MinPayRateDropdown = (MinPayRateDropdown);

// EXTERNAL MODULE: ./modules/JobSearchFilters/components/WorkTypeButtonGroup/WorkTypeButtonGroup.module.scss
var WorkTypeButtonGroup_module = __webpack_require__(86796);
var WorkTypeButtonGroup_module_default = /*#__PURE__*/__webpack_require__.n(WorkTypeButtonGroup_module);
;// CONCATENATED MODULE: ./modules/JobSearchFilters/components/WorkTypeButtonGroup/WorkTypeButtonGroup.tsx








var WorkTypeButtonGroup = function(param) {
    var selectedWorkType = param.selectedWorkType, onWorkTypeChange = param.onWorkTypeChange, className = param.className;
    var workTypeButtons = [
        "All",
        "Locum",
        "Permanent"
    ];
    var getWorkTypeButtonProps = function(buttonLabel) {
        return selectedWorkType === buttonLabel || !selectedWorkType && buttonLabel === "All" ? {
            variant: "contained",
            color: "primary",
            className: classnames_default()((WorkTypeButtonGroup_module_default()).workTypeButton, (WorkTypeButtonGroup_module_default())["workTypeButton--active"]),
            "aria-current": true
        } : {
            variant: "outlined",
            color: "default",
            className: (WorkTypeButtonGroup_module_default()).workTypeButton
        };
    };
    var handleWorkTypeChange = function(buttonLabel) {
        return function() {
            onWorkTypeChange(buttonLabel === "All" ? undefined : buttonLabel);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* default */.Z, {
        id: "workTypeButtonGroup",
        "data-testid": "job-search-work-type-button-group",
        disableElevation: true,
        className: classnames_default()((WorkTypeButtonGroup_module_default()).container, className),
        "aria-label": "Work type",
        fullWidth: true,
        children: workTypeButtons.map(function(buttonLabel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getWorkTypeButtonProps(buttonLabel)), {
                onClick: handleWorkTypeChange(buttonLabel),
                "data-testid": "job-search-work-type-".concat(buttonLabel, "-button"),
                children: buttonLabel.toUpperCase()
            }), buttonLabel);
        })
    });
};
/* harmony default export */ var WorkTypeButtonGroup_WorkTypeButtonGroup = (WorkTypeButtonGroup);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FilterListOutlined.js
var FilterListOutlined = __webpack_require__(38333);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowDownOutlined.js
var KeyboardArrowDownOutlined = __webpack_require__(79192);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowUpOutlined.js
var KeyboardArrowUpOutlined = __webpack_require__(25416);
// EXTERNAL MODULE: ./modules/JobSearchFilters/components/JobSearchFiltersForm/JobSearchFiltersForm.module.scss
var JobSearchFiltersForm_module = __webpack_require__(60251);
var JobSearchFiltersForm_module_default = /*#__PURE__*/__webpack_require__.n(JobSearchFiltersForm_module);
;// CONCATENATED MODULE: ./modules/JobSearchFilters/components/JobSearchFiltersForm/JobSearchFiltersForm.tsx
















var JobSearchFiltersForm = function(param) {
    var date = param.date, onDateChange = param.onDateChange, grade = param.grade, onGradeChange = param.onGradeChange, speciality = param.speciality, onSpecialityChange = param.onSpecialityChange, keyword = param.keyword, onKeywordChange = param.onKeywordChange, workType = param.workType, onWorkTypeChange = param.onWorkTypeChange, radius = param.radius, onRadiusChange = param.onRadiusChange, locationCoordinate = param.locationCoordinate, onLocationCoordinateChange = param.onLocationCoordinateChange, minPayRate = param.minPayRate, onMinPayRateChange = param.onMinPayRateChange, minPayRateUnit = param.minPayRateUnit, onMinPayRateUnitChange = param.onMinPayRateUnitChange, isEndDateDisabled = param.isEndDateDisabled, isRadiusDisabled = param.isRadiusDisabled, onClear = param.onClear, getGradeOptions = param.getGradeOptions, getSpecialityOptions = param.getSpecialityOptions, subspeciality = param.subspeciality, onSubSpecialityChange = param.onSubSpecialityChange, getSubSpecialityOptions = param.getSubSpecialityOptions, rootSpeciality = param.rootSpeciality, onRootSpecialityChange = param.onRootSpecialityChange, getRootSpecialityOptions = param.getRootSpecialityOptions;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var isCollapsible = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    // by default, should be closed on mobile and opened otherwise
    (0,react.useEffect)(function() {
        setIsOpen(isCollapsible === false);
    }, [
        isCollapsible
    ]);
    var handleOpenClick = function() {
        if (isCollapsible) {
            setIsOpen(!isOpen);
        }
    };
    var handleKeywordChange = lodash_debounce_default()(function(e) {
        return onKeywordChange(e.target.value);
    }, 500);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "job-filters-container",
        className: (JobSearchFiltersForm_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (JobSearchFiltersForm_module_default()).header,
                onClick: handleOpenClick,
                disabled: isCollapsible === false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterListOutlined/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (JobSearchFiltersForm_module_default()).header_text,
                        children: "Filters"
                    }),
                    isCollapsible && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (JobSearchFiltersForm_module_default()).header_downIcon,
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUpOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDownOutlined/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: isOpen,
                timeout: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (JobSearchFiltersForm_module_default()).body,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownList/* default */.Z, {
                                id: "grade",
                                label: "Grade",
                                value: grade,
                                testId: "job-search-grade-input",
                                onChange: function(e) {
                                    onGradeChange("" + e.target.value);
                                    clearScrollWhenSearchCriteriaHasChanged();
                                },
                                renderOptions: getGradeOptions
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownList/* default */.Z, {
                                id: "rootSpeciality",
                                label: "Speciality",
                                value: rootSpeciality,
                                testId: "job-search-root-speciality-input",
                                onChange: function(e) {
                                    onRootSpecialityChange("" + e.target.value);
                                    clearScrollWhenSearchCriteriaHasChanged();
                                },
                                renderOptions: getRootSpecialityOptions
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownList/* default */.Z, {
                                id: "subspeciality",
                                label: "Subspeciality",
                                value: subspeciality,
                                testId: "job-search-sub-speciality-input",
                                onChange: function(e) {
                                    onSubSpecialityChange("" + e.target.value);
                                    clearScrollWhenSearchCriteriaHasChanged();
                                },
                                renderOptions: getSubSpecialityOptions
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (JobSearchFiltersForm_module_default()).workType,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkTypeButtonGroup_WorkTypeButtonGroup, {
                                selectedWorkType: workType,
                                onWorkTypeChange: function(workType) {
                                    onWorkTypeChange(workType);
                                    clearScrollWhenSearchCriteriaHasChanged();
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSearchAutocomplete/* default */.Z, {
                                selectedLocation: locationCoordinate,
                                onSelectedLocationChange: onLocationCoordinateChange
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownList/* default */.Z, {
                                id: "radius",
                                label: "Radius",
                                value: radius,
                                testId: "job-search-radius-input",
                                disabled: isRadiusDisabled,
                                tooltipMessage: isRadiusDisabled ? "Radius is available when a specific city or town is selected." : undefined,
                                onChange: function(e) {
                                    onRadiusChange(e.target.value);
                                    clearScrollWhenSearchCriteriaHasChanged();
                                },
                                renderOptions: function() {
                                    return (0,jobSearchBoxOptions/* getRadiusOptions */.B5)();
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (JobSearchFiltersForm_module_default()).dates,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickers_DatePickers, {
                                date: date,
                                onDateChange: onDateChange,
                                isEndDateDisabled: isEndDateDisabled
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearableTextField_ClearableTextField, {
                                    id: "keywords",
                                    name: "keywords",
                                    placeholder: "Keywords",
                                    label: "Keywords",
                                    defaultValue: keyword !== null && keyword !== void 0 ? keyword : "",
                                    onChange: handleKeywordChange,
                                    inputProps: {
                                        "data-testid": "job-search-keywords-input"
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinPayRateDropdown_MinPayRateDropdown, {
                                minPayRate: minPayRate,
                                onMinPayRateChange: onMinPayRateChange,
                                minPayRateUnit: minPayRateUnit,
                                onMinPayRateUnitChange: onMinPayRateUnitChange
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (JobSearchFiltersForm_module_default()).clear,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "button",
                                onClick: onClear,
                                color: "primary",
                                size: "medium",
                                variant: "text",
                                "data-testid": "job-search-clear",
                                className: (JobSearchFiltersForm_module_default()).clearButton,
                                children: "Clear all"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var JobSearchFiltersForm_JobSearchFiltersForm = (JobSearchFiltersForm);

// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/jobLocationsHelper.ts
var jobLocationsHelper = __webpack_require__(29749);
// EXTERNAL MODULE: ./utils/jobSearchCookies.tsx
var jobSearchCookies = __webpack_require__(80059);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./modules/JobSearchFilters/components/JobSearchFilters/JobSearchFilters.tsx
















var JobSearchFilters = function(param) {
    var query = param.query;
    var handleChange = function handleChange(search) {
        router.push((0,jobListingHelper/* generateJobListingsUrlObject */.hX)(search));
    };
    var handleClearAll = function handleClearAll() {
        setRadius(undefined);
        setWorkType(undefined);
        setKeywords(undefined);
        setGrade(undefined);
        setSpeciality(undefined);
        setDate({
            startDate: null,
            endDate: null
        });
        setLocationCoordinate(null);
        setMinPayRate(null);
        setMinPayRateUnit(jobSearchBoxOptions/* DEFAULT_MIN_PAY_RATE_UNIT */.i$);
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "clear",
                filter_value: "all"
            },
            search: {}
        });
        handleChange({});
    };
    var getGradeOpts = function getGradeOpts() {
        return (0,jobSearchBoxOptions/* getGradeOptions */.mG)(grades);
    };
    var getSpecialityOpts = function getSpecialityOpts() {
        return (0,jobSearchBoxOptions/* getSpecialityOptions */.Lc)(grade, specialities);
    };
    var getRootSpecialityOpts = function getRootSpecialityOpts() {
        return (0,jobSearchBoxOptions/* getRootSpecialityOptions */.Tu)(grade, rootSpecialities);
    };
    var getSubSpecialityOpts = function getSubSpecialityOpts() {
        return (0,jobSearchBoxOptions/* getSubSpecialityOptions */.HN)(rootSpeciality, subSpecialities);
    };
    var formatLocation = function formatLocation(newLocationCoordinate) {
        var ref, ref1, ref2;
        return {
            location: newLocationCoordinate === null || newLocationCoordinate === void 0 ? void 0 : (ref = newLocationCoordinate.searchLocations) === null || ref === void 0 ? void 0 : ref.join(";"),
            locationName: newLocationCoordinate === null || newLocationCoordinate === void 0 ? void 0 : newLocationCoordinate.name,
            lon: newLocationCoordinate === null || newLocationCoordinate === void 0 ? void 0 : (ref1 = newLocationCoordinate.position) === null || ref1 === void 0 ? void 0 : ref1.lon.toString(),
            lat: newLocationCoordinate === null || newLocationCoordinate === void 0 ? void 0 : (ref2 = newLocationCoordinate.position) === null || ref2 === void 0 ? void 0 : ref2.lat.toString()
        };
    };
    var formatPayRate = function formatPayRate(newMinPayRate) {
        return {
            minPayRate: newMinPayRate,
            minPayRateUnit: newMinPayRate ? minPayRateUnit : undefined
        };
    };
    var generateSearchObject = function generateSearchObject(changedProps) {
        return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, date), {
            grade: grade,
            speciality: speciality,
            rootSpeciality: rootSpeciality,
            subspeciality: subspeciality,
            keywords: keywords,
            workType: workType
        }), formatPayRate(minPayRate), formatLocation(locationCoordinate)), {
            radius: radius,
            sortBy: query === null || query === void 0 ? void 0 : query.sortBy,
            page: 1
        }), changedProps);
    };
    var handleDateChange = function handleDateChange(newDate) {
        // only handle date changes when the date is valid to allow a possibility of typing dates in manually
        setDate(newDate);
        var search = generateSearchObject(newDate);
        if (date.startDate === newDate.startDate && date.endDate !== newDate.endDate && // end date changed and
        (0,dateHelper/* isValidDate */.qb)(newDate.endDate, "YYYY-MM-DD") // and it is valid
        ) {
            track("Apply Job Search Filter", {
                applied_filter: {
                    filter_type: "endDate",
                    filter_value: newDate.endDate
                },
                search: search
            });
            handleChange(search);
        }
        if (date.startDate !== newDate.startDate && // start date changed
        date.endDate === newDate.endDate && (0,dateHelper/* isValidDate */.qb)(newDate.startDate, "YYYY-MM-DD") // and it is valid
        ) {
            track("Apply Job Search Filter", {
                applied_filter: {
                    filter_type: "startDate",
                    filter_value: newDate.startDate
                },
                search: search
            });
            handleChange(search);
        }
    };
    var handleSpecialtyChange = function handleSpecialtyChange(newSpeciality) {
        setSpeciality(newSpeciality);
        var search = generateSearchObject({
            speciality: newSpeciality
        });
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "speciality",
                filter_value: newSpeciality
            },
            search: search
        });
        if (newSpeciality) {
            (0,jobSearchCookies/* setSpecialityCookie */.Me)(newSpeciality);
        }
        handleChange(search);
    };
    var handleSubSpecialityChange = function handleSubSpecialityChange(newSubSpeciality) {
        setSubspeciality(newSubSpeciality);
        var search = generateSearchObject({
            subspeciality: newSubSpeciality
        });
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "subspeciality",
                filter_value: newSubSpeciality
            },
            search: search
        });
        handleChange(search);
    };
    var handleKeywordsChange = function handleKeywordsChange(newKeywords) {
        setKeywords(newKeywords);
        var search = generateSearchObject({
            keywords: newKeywords
        });
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "keywords",
                filter_value: newKeywords
            },
            search: search
        });
        handleChange(search);
    };
    var handleWorkTypeChange = function handleWorkTypeChange(newWorkType) {
        // side effects: end date
        // - reset end date if Permanent is selected
        setWorkType(newWorkType);
        var newEndDate = date.endDate;
        if (newWorkType === "Permanent") {
            setDate({
                startDate: date.startDate,
                endDate: null
            });
            newEndDate = null;
        }
        var search = generateSearchObject({
            workType: newWorkType,
            endDate: newEndDate
        });
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "workType",
                filter_value: newWorkType
            },
            search: search
        });
        handleChange(search);
    };
    var handleLocationChange = function handleLocationChange(newLocationCoordinate) {
        // side effects: radius
        // - set to default or remove depending on type of location
        var newLocation = formatLocation(newLocationCoordinate);
        var newRadius = (newLocation === null || newLocation === void 0 ? void 0 : newLocation.lat) && (newLocation === null || newLocation === void 0 ? void 0 : newLocation.lon) ? radius !== null && radius !== void 0 ? radius : jobSearchBoxOptions/* DEFAULT_RADIUS */.J_ : undefined;
        setLocationCoordinate(newLocationCoordinate);
        setRadius(newRadius);
        var search = generateSearchObject((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newLocation), {
            radius: newRadius
        }));
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "location",
                filter_value: newLocation
            },
            search: search
        });
        if (newLocationCoordinate) {
            (0,jobSearchCookies/* setLocationCookie */.Hl)(newLocationCoordinate);
        }
        handleChange(search);
    };
    var handleRadiusChange = function handleRadiusChange(newRadius) {
        setRadius(newRadius);
        var search = generateSearchObject({
            radius: newRadius
        });
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "radius",
                filter_value: newRadius
            },
            search: search
        });
        handleChange(search);
    };
    var handleMinPayRateChange = function handleMinPayRateChange(newMinPayRate) {
        // side effects: minPayRateUnit
        // - set to default or remove
        setMinPayRate(newMinPayRate);
        var newPayRate = formatPayRate(newMinPayRate);
        var search = generateSearchObject(newPayRate);
        track("Apply Job Search Filter", {
            applied_filter: {
                filter_type: "minPayRate",
                filter_value: newPayRate
            },
            search: search
        });
        handleChange(search);
    };
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var track = (0,useAnalytics/* useAnalytics */.z)();
    // grade and speciality lists
    var ref3 = (0,react.useState)([
        {
            key: "Loading",
            value: "Loading"
        }, 
    ]), grades = ref3[0], setGrades = ref3[1];
    var ref4 = (0,react.useState)({}), specialities = ref4[0], setSpecialities = ref4[1];
    var ref5 = (0,react.useState)({}), rootSpecialities = ref5[0], setRootSpecialities = ref5[1];
    var ref6 = (0,react.useState)({}), subSpecialities = ref6[0], setSubSpecialities = ref6[1];
    var ref7, ref8;
    // form state
    var ref9 = (0,react.useState)({
        startDate: (ref7 = query === null || query === void 0 ? void 0 : query.startDate) !== null && ref7 !== void 0 ? ref7 : null,
        endDate: (ref8 = query === null || query === void 0 ? void 0 : query.endDate) !== null && ref8 !== void 0 ? ref8 : null
    }), date = ref9[0], setDate = ref9[1];
    var ref10 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.grade), grade = ref10[0], setGrade = ref10[1];
    // TODO: update the below speciality states when ready
    var ref11 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.speciality), speciality = ref11[0], setSpeciality = ref11[1];
    var ref12 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.rootSpeciality), rootSpeciality = ref12[0], setRootSpeciality = ref12[1];
    var ref13 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.subspeciality), subspeciality = ref13[0], setSubspeciality = ref13[1];
    var ref14 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.keywords), keywords = ref14[0], setKeywords = ref14[1];
    var ref15 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.workType), workType = ref15[0], setWorkType = ref15[1];
    var ref16 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.radius), radius = ref16[0], setRadius = ref16[1];
    var ref17 = (0,react.useState)({
        name: (query === null || query === void 0 ? void 0 : query.locationName) ? query === null || query === void 0 ? void 0 : query.locationName : (0,jobLocationsHelper/* generateLocationNameFromLocationString */.q2)(query === null || query === void 0 ? void 0 : query.location),
        position: (query === null || query === void 0 ? void 0 : query.lat) && (query === null || query === void 0 ? void 0 : query.lon) ? {
            lat: +query.lat,
            lon: +query.lon
        } : undefined,
        searchLocations: (query === null || query === void 0 ? void 0 : query.location) ? (ref = query.location) === null || ref === void 0 ? void 0 : ref.split(";") : undefined
    }), locationCoordinate = ref17[0], setLocationCoordinate = ref17[1];
    var ref18;
    var ref19 = (0,react.useState)((ref18 = query === null || query === void 0 ? void 0 : query.minPayRate) !== null && ref18 !== void 0 ? ref18 : null), minPayRate = ref19[0], setMinPayRate = ref19[1];
    var ref20;
    var ref21 = (0,react.useState)((ref20 = query === null || query === void 0 ? void 0 : query.minPayRateUnit) !== null && ref20 !== void 0 ? ref20 : jobSearchBoxOptions/* DEFAULT_MIN_PAY_RATE_UNIT */.i$), minPayRateUnit = ref21[0], setMinPayRateUnit = ref21[1];
    // end of form state
    var isEndDateDisabled = workType === "Permanent";
    var isRadiusDisabled = !((locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref1 = locationCoordinate.position) === null || ref1 === void 0 ? void 0 : ref1.lon) && (locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref2 = locationCoordinate.position) === null || ref2 === void 0 ? void 0 : ref2.lat));
    var getSpecialityByGrade = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newGrade) {
            var filteredGrade, specialitiesPerGrade, result, specialitiesSet;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!newGrade || newGrade === "none") {
                            return [
                                2,
                                undefined
                            ];
                        }
                        filteredGrade = newGrade;
                        if (!specialities[filteredGrade]) return [
                            3,
                            1
                        ];
                        specialitiesPerGrade = specialities[filteredGrade];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            (0,useRequest/* getSpecialities */.hZ)(filteredGrade)
                        ];
                    case 2:
                        result = _state.sent();
                        if ("error" in result) {
                            // the error get reported by makeRequestAndNoticeErrors, and we don't show any notification to the user
                            return [
                                2,
                                undefined
                            ];
                        } else {
                            setSpecialities((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, specialities), (0,_define_property/* default */.Z)({}, filteredGrade, result.response.data)));
                            specialitiesPerGrade = result.response.data;
                        }
                        _state.label = 3;
                    case 3:
                        // reset selected speciality if it is not found in the allowed specialty values
                        if (specialitiesPerGrade && specialitiesPerGrade.length > 0) {
                            specialitiesSet = new Set(specialitiesPerGrade.map(function(i) {
                                return i.value;
                            }));
                            return [
                                2,
                                specialitiesSet.has(speciality) ? speciality : undefined
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return function getSpecialityByGrade(newGrade) {
            return _ref.apply(this, arguments);
        };
    }();
    var getRootSpecialityByGrade = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newGrade) {
            var filteredGrade, rootSpecialitiesPerGrade, result, rootSpecialitiesSet;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!newGrade || newGrade === "none") {
                            return [
                                2,
                                undefined
                            ];
                        }
                        filteredGrade = newGrade;
                        if (!rootSpecialities[filteredGrade]) return [
                            3,
                            1
                        ];
                        rootSpecialitiesPerGrade = rootSpecialities[filteredGrade];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            (0,useRequest/* getRootSpecialtiesV2 */.uW)(filteredGrade)
                        ];
                    case 2:
                        result = _state.sent();
                        if ("error" in result) {
                            // the error get reported by makeRequestAndNoticeErrors, and we don't show any notification to the user
                            return [
                                2,
                                undefined
                            ];
                        } else {
                            setRootSpecialities((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rootSpecialities), (0,_define_property/* default */.Z)({}, filteredGrade, result.response.data)));
                            rootSpecialitiesPerGrade = result.response.data;
                        }
                        _state.label = 3;
                    case 3:
                        // reset selected speciality if it is not found in the allowed specialty values
                        if (rootSpecialitiesPerGrade && rootSpecialitiesPerGrade.length > 0) {
                            rootSpecialitiesSet = new Set(rootSpecialitiesPerGrade.map(function(i) {
                                return i.value;
                            }));
                            return [
                                2,
                                rootSpecialitiesSet.has(rootSpeciality) ? rootSpeciality : undefined
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return function getRootSpecialityByGrade(newGrade) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSubSpecialityByRootSpeciality = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newGrade, rootSpeciality) {
            var subSpecialitiesPerRootSpeciality, result, subSpecialitiesSet;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!newGrade || newGrade === "none") {
                            return [
                                2,
                                undefined
                            ];
                        }
                        if (!rootSpeciality || rootSpeciality === "none") {
                            return [
                                2,
                                undefined
                            ];
                        }
                        return [
                            4,
                            (0,useRequest/* getSubSpecialitiesV2 */.n5)(newGrade, rootSpeciality)
                        ];
                    case 1:
                        result = _state.sent();
                        if ("error" in result) {
                            // the error get reported by makeRequestAndNoticeErrors, and we don't show any notification to the user
                            return [
                                2,
                                undefined
                            ];
                        } else {
                            setSubSpecialities((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subSpecialities), (0,_define_property/* default */.Z)({}, rootSpeciality, result.response.data)));
                            subSpecialitiesPerRootSpeciality = result.response.data;
                        }
                        // reset selected speciality if it is not found in the allowed specialty values
                        if (subSpecialitiesPerRootSpeciality && subSpecialitiesPerRootSpeciality.length > 0) {
                            subSpecialitiesSet = new Set(subSpecialitiesPerRootSpeciality.map(function(i) {
                                return i.value;
                            }));
                            return [
                                2,
                                subSpecialitiesSet.has(subspeciality) ? subspeciality : undefined
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return function getSubSpecialityByRootSpeciality(newGrade, rootSpeciality) {
            return _ref.apply(this, arguments);
        };
    }();
    // Fetch the list of grades and specialties on initial load
    (0,react.useEffect)(function() {
        var getJobGradesAndSpecialtiesV1 = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var grades, speciality, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,useRequest/* getJobGrades */.TI)()
                            ];
                        case 1:
                            grades = _state.sent();
                            setGrades(grades);
                            return [
                                4,
                                getSpecialityByGrade(query === null || query === void 0 ? void 0 : query.grade)
                            ];
                        case 2:
                            speciality = _state.sent();
                            setSpeciality(speciality);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            // error already reported by makeRequestAndNoticeErrors
                            return [
                                2,
                                null
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getJobGradesAndSpecialtiesV1() {
                return _ref.apply(this, arguments);
            };
        }();
        var getJobGradesAndRootSpecialtiesAndSubSpecialitiesV2 = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var grades, rootSpeciality, subspeciality, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                (0,useRequest/* getJobGrades */.TI)()
                            ];
                        case 1:
                            grades = _state.sent();
                            setGrades(grades);
                            return [
                                4,
                                getRootSpecialityByGrade(query === null || query === void 0 ? void 0 : query.grade)
                            ];
                        case 2:
                            rootSpeciality = _state.sent();
                            setRootSpeciality(rootSpeciality);
                            return [
                                4,
                                getSubSpecialityByRootSpeciality(query === null || query === void 0 ? void 0 : query.grade, rootSpeciality)
                            ];
                        case 3:
                            subspeciality = _state.sent();
                            setSubspeciality(subspeciality);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            // error already reported by makeRequestAndNoticeErrors
                            return [
                                2,
                                null
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getJobGradesAndRootSpecialtiesAndSubSpecialitiesV2() {
                return _ref.apply(this, arguments);
            };
        }();
        getJobGradesAndRootSpecialtiesAndSubSpecialitiesV2();
    }, []);
    function handleGradeChange(newGrade) {
        return _handleGradeChange.apply(this, arguments);
    }
    function _handleGradeChange() {
        _handleGradeChange = (0,_async_to_generator/* default */.Z)(function(newGrade) {
            var newRootSpeciality, newSubspeciality, search;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getRootSpecialityByGrade(newGrade)
                        ];
                    case 1:
                        newRootSpeciality = _state.sent();
                        setRootSpeciality(newRootSpeciality);
                        return [
                            4,
                            getSubSpecialityByRootSpeciality(newGrade, newRootSpeciality)
                        ];
                    case 2:
                        newSubspeciality = _state.sent();
                        setSubspeciality(newSubspeciality);
                        search = generateSearchObject({
                            grade: newGrade,
                            rootSpeciality: newRootSpeciality,
                            subspeciality: newSubspeciality
                        });
                        setGrade(newGrade);
                        track("Apply Job Search Filter", {
                            applied_filter: {
                                filter_type: "grade",
                                filter_value: newGrade
                            },
                            search: search
                        });
                        if (newGrade) {
                            (0,jobSearchCookies/* setGradeCookie */.r8)(newGrade);
                        }
                        handleChange(search);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleGradeChange.apply(this, arguments);
    }
    function handleRootSpecialityChange(newRootSpeciality) {
        return _handleRootSpecialityChange.apply(this, arguments);
    }
    function _handleRootSpecialityChange() {
        _handleRootSpecialityChange = (0,_async_to_generator/* default */.Z)(function(newRootSpeciality) {
            var newSubSpeciality, search;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getSubSpecialityByRootSpeciality(grade, newRootSpeciality)
                        ];
                    case 1:
                        newSubSpeciality = _state.sent();
                        setRootSpeciality(newRootSpeciality);
                        setSubspeciality(newSubSpeciality);
                        search = generateSearchObject({
                            rootSpeciality: newRootSpeciality,
                            subspeciality: newSubSpeciality
                        });
                        track("Apply Job Search Filter", {
                            applied_filter: {
                                filter_type: "rootSpeciality",
                                filter_value: newRootSpeciality
                            },
                            search: search
                        });
                        handleChange(search);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleRootSpecialityChange.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchFiltersForm_JobSearchFiltersForm, {
        date: date,
        onDateChange: handleDateChange,
        grade: grade,
        onGradeChange: function(grade) {
            handleGradeChange(grade).then(function() {
                return null;
            }).catch(function() {
                return null;
            }); // the error get reported by makeRequestAndNoticeErrors, and we don't show any notification to the user
        },
        speciality: speciality,
        onSpecialityChange: handleSpecialtyChange,
        keyword: keywords,
        onKeywordChange: handleKeywordsChange,
        workType: workType,
        onWorkTypeChange: handleWorkTypeChange,
        locationCoordinate: locationCoordinate,
        onLocationCoordinateChange: handleLocationChange,
        radius: radius,
        onRadiusChange: handleRadiusChange,
        minPayRate: minPayRate,
        onMinPayRateChange: handleMinPayRateChange,
        minPayRateUnit: minPayRateUnit,
        onMinPayRateUnitChange: setMinPayRateUnit,
        isEndDateDisabled: isEndDateDisabled,
        isRadiusDisabled: isRadiusDisabled,
        onClear: handleClearAll,
        getGradeOptions: getGradeOpts,
        getSpecialityOptions: getSpecialityOpts,
        rootSpeciality: rootSpeciality,
        onRootSpecialityChange: function(rootSpeciality) {
            handleRootSpecialityChange(rootSpeciality).then(function() {
                return null;
            }).catch(function() {
                return null;
            }); // Same behaviour as grade now we have sub specialities
        },
        subspeciality: subspeciality,
        onSubSpecialityChange: handleSubSpecialityChange,
        getRootSpecialityOptions: getRootSpecialityOpts,
        getSubSpecialityOptions: getSubSpecialityOpts
    });
};
/* harmony default export */ var JobSearchFilters_JobSearchFilters = (JobSearchFilters);

;// CONCATENATED MODULE: ./modules/JobSearchFilters/index.tsx


// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Pagination/Pagination.js + 6 modules
var Pagination = __webpack_require__(72221);
// EXTERNAL MODULE: ./modules/JobListingJobCardList/index.tsx + 5 modules
var JobListingJobCardList = __webpack_require__(51241);
// EXTERNAL MODULE: ./modules/JobListing/JobListing.module.scss
var JobListing_module = __webpack_require__(39514);
var JobListing_module_default = /*#__PURE__*/__webpack_require__.n(JobListing_module);
// EXTERNAL MODULE: ./components/Alert/index.ts + 1 modules
var Alert = __webpack_require__(54978);
;// CONCATENATED MODULE: ./modules/JobListing/components/JobAlertsBanner/JobAlertsBanner.tsx



var getJobAlertsBannerPropsMap = function() {
    return {
        none: {
            type: "info",
            message: "",
            "data-testid": ""
        },
        "select-search-criteria": {
            type: "info",
            message: "Select search criteria to receive a job alert by email when new jobs match.",
            "data-testid": "job-listing-alert-select-search-criteria"
        },
        "select-subspeciality": {
            type: "info",
            message: "Please select a subspeciality of Medicine to save a job alert.",
            "data-testid": "job-listing-alert-select-subspeciality"
        },
        "job-alert-create": {
            type: "alert",
            message: "Save this search to receive job alerts by email when new jobs match.",
            "data-testid": "job-listing-alert-notice",
            buttonType: "createAlert"
        },
        "manage-job-alert": {
            type: "info",
            message: "Your job search has been saved, and an alert has been set up.",
            "data-testid": "job-listing-manage-alert-notice",
            buttonType: "manageAlert"
        }
    };
};
var JobAlertsBanner = function(param) {
    var jobListingAlertBanner = param.jobListingAlertBanner, onSave = param.onSave, onManage = param.onManage;
    if (jobListingAlertBanner === "none") {
        return null;
    }
    var alertBannerProps = getJobAlertsBannerPropsMap()[jobListingAlertBanner];
    var type = alertBannerProps.type, message = alertBannerProps.message, buttonType = alertBannerProps.buttonType;
    var getAlertButton = function() {
        if (!buttonType) {
            return null;
        }
        return buttonType === "createAlert" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            "data-testid": "job-listing-create-alert-button",
            onClick: onSave,
            children: "Save\xa0alert"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            "data-testid": "job-listing-manage-alert-button",
            onClick: onManage,
            children: "Manage your job alerts"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
        type: type,
        message: message,
        "data-testid": alertBannerProps["data-testid"],
        callToActionChildren: getAlertButton()
    });
};
/* harmony default export */ var JobAlertsBanner_JobAlertsBanner = (JobAlertsBanner);

// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./modules/JobListing/components/NoResultsMessage/NoResultsMessage.module.scss
var NoResultsMessage_module = __webpack_require__(75672);
var NoResultsMessage_module_default = /*#__PURE__*/__webpack_require__.n(NoResultsMessage_module);
;// CONCATENATED MODULE: ./modules/JobListing/components/NoResultsMessage/NoResultsMessage.tsx





function NoResultsMessage() {
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var signUpUrl = "".concat(profileUrl, "/sign-up");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NoResultsMessage_module_default()).emptyDataNotice,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: (NoResultsMessage_module_default()).heading,
                variant: "h6",
                component: "p",
                "data-testid": "job-search-no-results-message",
                children: "There are no jobs matching your criteria"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body1",
                component: "p",
                children: [
                    "You can try broadening your search criteria or let us do the searching for you! Our team can help match you with your ideal job -",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        href: signUpUrl,
                        as: signUpUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: "simply register now."
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var NoResultsMessage_NoResultsMessage = (NoResultsMessage);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 6 modules
var Select = __webpack_require__(66851);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./modules/JobListing/components/ResultsHeader/ResultsHeader.module.scss
var ResultsHeader_module = __webpack_require__(75739);
var ResultsHeader_module_default = /*#__PURE__*/__webpack_require__.n(ResultsHeader_module);
;// CONCATENATED MODULE: ./modules/JobListing/components/ResultsHeader/ResultsHeader.tsx







var getJobResultText = function(query, total) {
    var jobsText = "job".concat(total !== 1 ? "s" : "");
    if (query.grade && !query.speciality) {
        return "".concat(total, " ").concat(query.grade, " ").concat(jobsText, " found");
    }
    if (query.grade && query.speciality) {
        return "".concat(total, " ").concat(query.speciality, " ").concat(query.grade, " ").concat(jobsText, " found");
    }
    return "".concat(total, " ").concat(jobsText, " found");
};
function ResultsHeader(param) {
    var jobSpecialitiesMapped = param.jobSpecialitiesMapped, query = param.query, total = param.total, isNonSchedulerLocationSelected = param.isNonSchedulerLocationSelected, mobile = param.mobile, radiusInKm = param.radiusInKm, sortByClick = param.sortByClick, trackingDetails = param.trackingDetails;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var _sortBy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        className: (ResultsHeader_module_default()).resultsHeader,
        container: true,
        direction: "row",
        justifyContent: "space-between",
        children: [
            jobSpecialitiesMapped && query.speciality && jobSpecialitiesMapped[query.speciality] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 12,
                className: (ResultsHeader_module_default()).specialtyMessageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    children: jobSpecialitiesMapped[query.speciality].description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                xs: 8,
                className: (ResultsHeader_module_default()).resultMessageWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (ResultsHeader_module_default()).totalHeader,
                        "data-testid": "job-search-results-message",
                        children: getJobResultText(query, total)
                    }),
                    isNonSchedulerLocationSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ResultsHeader_module_default()).radius,
                        "data-testid": "job-search-results-radius-message",
                        children: !mobile ? "Within a ".concat(radiusInKm, " km radius of the selected location") : "Within ".concat(radiusInKm, " km radius")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ResultsHeader_module_default()).sortby,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        displayEmpty: true,
                        IconComponent: ArrowBackIos/* default */.Z,
                        value: (_sortBy = query.sortBy) !== null && _sortBy !== void 0 ? _sortBy : "",
                        onChange: function(e) {
                            setScrollInstantOnFilterChangeRerender();
                            sortByClick(e.target.value);
                            track("Job results Sort By", (0,_object_spread/* default */.Z)({
                                sort_by: e.target.value
                            }, trackingDetails));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "",
                                children: "Sort By"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "MostRecent",
                                children: "Recently added"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: "HighestPaid",
                                children: "Highest paid"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var ResultsHeader_ResultsHeader = (ResultsHeader);

// EXTERNAL MODULE: ./modules/JobListing/components/SimilarJobsSection/SimilarJobsSection.module.scss
var SimilarJobsSection_module = __webpack_require__(53758);
var SimilarJobsSection_module_default = /*#__PURE__*/__webpack_require__.n(SimilarJobsSection_module);
;// CONCATENATED MODULE: ./modules/JobListing/components/SimilarJobsSection/SimilarJobsSection.tsx





function SimilarJobsSection(param) {
    var jobs = param.jobs, isUserLoggedIn = param.isUserLoggedIn, query = param.query, grade = param.grade, speciality = param.speciality, rootSpeciality = param.rootSpeciality, subspeciality = param.subspeciality, className = param.className, hasSearchResults = param.hasSearchResults;
    var getSpecialityMessage = function() {
        if (!rootSpeciality && !speciality) {
            return null;
        }
        return "- ".concat(rootSpeciality).concat(subspeciality ? " - ".concat(subspeciality) : "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SimilarJobsSection_module_default()).similarJobCard, className),
        "data-testid": "job-search-similar-jobs-results",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: hasSearchResults ? "h2" : "h1",
                className: (SimilarJobsSection_module_default()).heading,
                children: [
                    "Similar results to ",
                    grade,
                    " ",
                    getSpecialityMessage(),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingJobCardList/* default */.Z, {
                jobs: jobs,
                isUserLoggedIn: isUserLoggedIn,
                query: query,
                isHighlighted: true,
                ctaPosition: "bottom"
            })
        ]
    });
}
/* harmony default export */ var SimilarJobsSection_SimilarJobsSection = (SimilarJobsSection);

;// CONCATENATED MODULE: ./modules/JobListing/JobListing.tsx
























var getJobListingBannerType = function(query) {
    var JOB_ALERT_CREATION_QUERY_KEYS = [
        "grade",
        "speciality",
        "rootSpeciality",
        "subspeciality",
        "workType",
        "startDate",
        "endDate",
        "keywords",
        "locationName",
        "location",
        "minPayRate",
        "minPayRateUnit", 
    ];
    var isNonSchedulerLocationSelected = !!(query.lon && query.lat);
    var isPayRateRelatedSearch = !!(query.minPayRate && query.minPayRateUnit);
    var isMedicineOnlySearch = query.rootSpeciality === "Medicine" && !query.subspeciality;
    var isAbleToCreateJobAlert = Boolean(JOB_ALERT_CREATION_QUERY_KEYS.find(function(key) {
        return query[key];
    }));
    if (query.jobAlert === "Manage") {
        return "manage-job-alert";
    }
    if (isMedicineOnlySearch) {
        return "select-subspeciality";
    }
    if (isAbleToCreateJobAlert) {
        if (isNonSchedulerLocationSelected || isPayRateRelatedSearch) {
            return "none";
        } else {
            return "job-alert-create";
        }
    } else {
        return "select-search-criteria";
    }
};
var JobListing = function(param) {
    var _jobs = param.jobs, total = _jobs.total, data = _jobs.data, limit = _jobs.limit, _similarJobs = param.similarJobs, similarJobs = _similarJobs === void 0 ? [] : _similarJobs, query = param.query, jobSpecialities = param.jobSpecialities;
    var router = (0,next_router.useRouter)();
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    var scrollToResultsRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showDialog = ref[0], setShowDialog = ref[1];
    var trackingDetails = (0,jobListingHelper/* generateJobListTrackingDetails */.pE)(query, user);
    var mobile = (0,useMediaQuery/* default */.Z)("(max-width: 600px)");
    var radiusInKm = query.radius || jobSearchBoxOptions/* DEFAULT_RADIUS */.J_;
    var hasSearchResults = !!(data === null || data === void 0 ? void 0 : data.length);
    var hasSimilarResults = !!(similarJobs === null || similarJobs === void 0 ? void 0 : similarJobs.length);
    var isNonSchedulerLocationSelected = !!(query.lon && query.lat);
    var ref1 = (0,react.useState)(getJobListingBannerType(query)), jobListingAlertBanner = ref1[0], setJobListingAlertBanner = ref1[1];
    var jobSpecialitiesMapped = {};
    jobSpecialities.forEach(function(js) {
        jobSpecialitiesMapped[js.name] = js;
    });
    var sortByClick = function(type) {
        var search = {};
        search = Object.assign(search, query, {
            sortBy: type
        });
        if (!type) {
            delete search.sortBy;
        }
        router.push({
            pathname: path/* PATH.JOBSLIST */.m.JOBSLIST,
            query: search
        });
    };
    var handleJobAlertBannerSaveCLick = function() {
        track("Set up job alert button click", trackingDetails);
        if (!user) {
            // noinspection JSIgnoredPromiseFromCall
            router_default().push((0,urlHelper/* getRegisterUrlClientSide */.SE)("create_job_alert"));
        } else {
            setShowDialog(true);
        }
    };
    var handleJobAlertManageButtonClick = function() {
        track("Manage job alerts button click", trackingDetails);
        router.push(path/* PATH.JOBS_ALERTS */.m.JOBS_ALERTS);
    };
    var onJobAlertSave = function() {
        setJobListingAlertBanner("manage-job-alert");
    };
    (0,react.useEffect)(function() {
        setJobListingAlertBanner(getJobListingBannerType(query));
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        scrollToResultsWhenRendered(scrollToResultsRef);
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        track("Job Search Results", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            count: total,
            regCTAJobResultsView: user === null
        }));
    }, [
        router.query
    ]);
    var _grade;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "job-listing-module",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (JobListing_module_default()).pageHeadingCentered,
                children: "Search results"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (JobListing_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (JobListing_module_default()).alertContainer,
                                ref: scrollToResultsRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsBanner_JobAlertsBanner, {
                                    onSave: handleJobAlertBannerSaveCLick,
                                    onManage: handleJobAlertManageButtonClick,
                                    jobListingAlertBanner: jobListingAlertBanner
                                })
                            }),
                            !hasSearchResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultsMessage_NoResultsMessage, {}),
                            hasSearchResults && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsHeader_ResultsHeader, {
                                        jobSpecialitiesMapped: jobSpecialitiesMapped,
                                        query: query,
                                        total: total,
                                        isNonSchedulerLocationSelected: isNonSchedulerLocationSelected,
                                        mobile: mobile,
                                        radiusInKm: radiusInKm,
                                        sortByClick: sortByClick,
                                        trackingDetails: trackingDetails
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (JobListing_module_default()).jobCard,
                                        "data-testid": "job-search-jobs-listing-results",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingJobCardList/* default */.Z, {
                                            jobs: data,
                                            isUserLoggedIn: !!user,
                                            query: query,
                                            suppressCTABanner: hasSimilarResults
                                        })
                                    })
                                ]
                            }),
                            hasSimilarResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarJobsSection_SimilarJobsSection, {
                                className: classnames_default()((0,_define_property/* default */.Z)({}, (JobListing_module_default()).noResultsSimilarJobs, !hasSearchResults)),
                                // we should always have grade in this case
                                grade: (_grade = query.grade) !== null && _grade !== void 0 ? _grade : "",
                                speciality: query.speciality,
                                rootSpeciality: query.rootSpeciality,
                                subspeciality: query.subspeciality,
                                hasSearchResults: hasSearchResults,
                                jobs: similarJobs,
                                isUserLoggedIn: !!user,
                                query: query
                            }),
                            hasSearchResults && total > limit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (JobListing_module_default()).pagination,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                    count: Math.ceil(total / limit),
                                    page: query.page && +query.page || 1,
                                    variant: "outlined",
                                    shape: "rounded",
                                    color: "primary",
                                    onChange: function(_e, value) {
                                        track("JobsList pagination", {
                                            "Page number": value
                                        });
                                        if (query["listing"]) {
                                            delete query["listing"];
                                        }
                                        var newQuery = {};
                                        newQuery = Object.assign(newQuery, query);
                                        newQuery.page = value;
                                        router.push({
                                            pathname: location.pathname,
                                            query: newQuery
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (JobListing_module_default()).filters,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchFilters_JobSearchFilters, {
                            query: query
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlerts/* JobAlertPreferencesDialog */.gs, {
                query: (0,jobListingHelper/* convertJobSearchQueryToJobAlertQuery */.Xg)(query),
                show: showDialog,
                hide: function() {
                    setShowDialog(false);
                },
                successCallBack: onJobAlertSave
            })
        ]
    });
};
/* harmony default export */ var JobListing_JobListing = (JobListing);

;// CONCATENATED MODULE: ./modules/JobListing/index.tsx



/***/ }),

/***/ 73291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var modules_JobListing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72781);
/* harmony import */ var modules_UserLoggedinContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74304);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84306);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var JobsList = function(param) {
    var jobs = param.jobs, query = param.query, jobSpecialities = param.jobSpecialities, similarJobs = param.similarJobs;
    var title = "Search all doctor jobs in Australia & NZ";
    var description = "Find your next doctor job with Medrecruit. ".concat(jobs.total, " jobs available across Australia and NZ. Find better experiences & better pay. Free end to end service for doctors.");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_UserLoggedinContainer__WEBPACK_IMPORTED_MODULE_4__/* .UserLoggedinContainer */ .C, {
        size: "lg",
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().jobListContainer),
        style: modules_UserLoggedinContainer__WEBPACK_IMPORTED_MODULE_4__/* .ContainerStyle.TINY_BLUE_BANNER */ .N.TINY_BLUE_BANNER,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                canonical: "list",
                title: title,
                description: description,
                openGraph: {
                    title: title,
                    description: description
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_JobListing__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                jobs: jobs,
                query: query,
                jobSpecialities: jobSpecialities,
                similarJobs: similarJobs
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (JobsList);


/***/ }),

/***/ 63266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"Alert_messageContainer__BJner","callToActionChildren":"Alert_callToActionChildren__SaKwd","notice":"Alert_notice__aj_Wu"};

/***/ }),

/***/ 48166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textField":"ClearableTextField_textField__E7797","textFieldClearButton":"ClearableTextField_textFieldClearButton__vP6N8"};

/***/ }),

/***/ 39514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingCentered":"JobListing_pageHeadingCentered__DnZc_","noResultsSimilarJobs":"JobListing_noResultsSimilarJobs__feoVd","container":"JobListing_container__d5KkU","filters":"JobListing_filters__uhMl3","totalHeader":"JobListing_totalHeader__s28nD","notice":"JobListing_notice__eA_DP","pagination":"JobListing_pagination__qqOkk","flex":"JobListing_flex__RjDdv","jobCard":"JobListing_jobCard__1qsiO","alertContainer":"JobListing_alertContainer__oWLlC"};

/***/ }),

/***/ 75672:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptyDataNotice":"NoResultsMessage_emptyDataNotice__zv_h8","heading":"NoResultsMessage_heading__0UgPS"};

/***/ }),

/***/ 75739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resultsHeader":"ResultsHeader_resultsHeader___lRRl","specialtyMessageWrapper":"ResultsHeader_specialtyMessageWrapper__03Jeh","resultMessageWrapper":"ResultsHeader_resultMessageWrapper__HBJdv","totalHeader":"ResultsHeader_totalHeader__OcfNJ","radius":"ResultsHeader_radius__uZ07z","sortby":"ResultsHeader_sortby__X4uxo"};

/***/ }),

/***/ 53758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"similarJobCard":"SimilarJobsSection_similarJobCard__t_bD9","heading":"SimilarJobsSection_heading__vcti3"};

/***/ }),

/***/ 78192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DatePickers_container__xbP13","outlinedPicker":"DatePickers_outlinedPicker__ITA_c"};

/***/ }),

/***/ 60251:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSearchFiltersForm_container__ApUci","header":"JobSearchFiltersForm_header__3V4Ol","header_text":"JobSearchFiltersForm_header_text__lFn6A","header_downIcon":"JobSearchFiltersForm_header_downIcon__iBI_H","body":"JobSearchFiltersForm_body__tLEVM","workType":"JobSearchFiltersForm_workType__v7HHT","dates":"JobSearchFiltersForm_dates___jIkJ","clear":"JobSearchFiltersForm_clear__a1X_g","clearButton":"JobSearchFiltersForm_clearButton__3IcvZ"};

/***/ }),

/***/ 83333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MinPayRateDropdown_dropdown__K5f6O","buttonGroup":"MinPayRateDropdown_buttonGroup__EfWHS","button":"MinPayRateDropdown_button__cf7xj","active":"MinPayRateDropdown_active__wwYEU"};

/***/ }),

/***/ 86796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkTypeButtonGroup_container__Bgd3f","workTypeButton":"WorkTypeButtonGroup_workTypeButton__STXWm","workTypeButton--active":"WorkTypeButtonGroup_workTypeButton--active__C8lXu"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,9669,4872,807,9803,2283,9043,3496,2298,4485,3437,4577,946,6993,868,2277,7243,2628,933,7422,1241,7988,4501,9774,2888,179], function() { return __webpack_exec__(18295); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);